export {default as MainC} from './components/main';



// WEBPACK FOOTER //
// src/modules/asignacion/component.js